import React, { useEffect } from 'react'
import styled, { css } from 'styled-components'
import cn, { Argument as ClassName } from 'classnames'

import { Button } from '../common/components/Button'

const SDialog = styled.div<{ width?: number }>`
    ${(p) =>
        p.width
            ? css`
                  @media (min-width: 768px) {
                      width: ${p.width}px;
                  }
              `
            : ''}
`

const InnerDiv = styled.div`
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
        display: none;
    }
`

const BootstrapModalLayout: React.FC<Props> = ({
    children,
    title,
    loading,
    titleButton,
    actions,
    size = 'md',
    className,
    style,
    titleClassName = 'modal-header',
}) => {
    useEffect(() => {
        document.body.classList.add('no-scroll')

        return () => {
            document.body.classList.remove('no-scroll')
        }
    }, [])
    return (
        <React.Fragment>
            <div className="modal-backdrop" />
            <InnerDiv className={cn(className, 'modal-container')} tabIndex={-1} role="dialog">
                <SDialog
                    className={`modal-dialog modal-dialog-${size}`}
                    width={typeof size === 'number' ? size : undefined}
                >
                    <div className="modal-content" style={style}>
                        <div className="modal-titleContainer">
                            {title && (
                                <div className={titleClassName} data-testid="modalHeader">
                                    {title}
                                </div>
                            )}
                            {titleButton && <span>{titleButton}</span>}
                        </div>
                        <div className="modal-body">{children}</div>
                        {actions && actions.length ? (
                            <div className="modal-footer">
                                {actions.map(({ callback, btn = 'btn-ok', type, dataTestId, label, ...rest }) => (
                                    <Button
                                        key={label}
                                        type={type ?? 'button'}
                                        onClick={callback}
                                        data-testid={dataTestId || label}
                                        className={cn({ secondary: btn !== 'btn-ok' })}
                                        label={label}
                                        {...rest}
                                    />
                                ))}
                            </div>
                        ) : null}
                    </div>
                </SDialog>
            </InnerDiv>
        </React.Fragment>
    )
}

export default BootstrapModalLayout

export interface Action {
    label: string
    callback?: () => unknown
    minWidth?: string
    btn?: 'btn-ok' | 'btn-danger' | 'btn-danger' | 'btn-secondary'
    disabled?: boolean
    loading?: boolean
    type?: 'submit' | 'button'
    form?: string
    dataTestId?: string
}

export type Props = {
    title?: string | React.ReactNode
    children: React.ReactNode
    titleButton?: React.ReactElement
    loading?: boolean
    size?: 'sm' | 'md' | 'lg' | number
    titleClassName?: 'modal-header' | 'modal-header text-center'
    actions?: Action[]
    className?: ClassName
    style?: React.CSSProperties
}
